import logo from './logo.svg';
//import './App.css';

import FrontPage from './FrontPage'; 


import Feast from './Feast'; 






function App() {
  return (
   // <div className="App">
      <header >
 

<FrontPage/>

   
     
   
       
      </header>
   // </div>
  );
}

export default App;
